'use strict';

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { IEvent } from '@ispm-client/modules/events/Interfaces';
import { PacsLauncherService } from '../services/pacs-launcher.service';

@Component({
  selector: 'ispm-pacs-launcher',
  templateUrl: './pacs-launcher.component.html',
  styleUrls: ['./pacs-launcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PacsLauncherComponent {
  public launchPacsEnabled: boolean = true;

  constructor(private pacsLauncherService: PacsLauncherService) { }

  @Input() set currentEvent(event: IEvent){
    this.pacsLauncherService.setCurrentEvent(event);
    this.launchPacsEnabled = this.pacsLauncherService.getEnabledStatus();
  }

  launchPacs(){
    this.pacsLauncherService.sendLaunchRequest();
  }
}
